import { CultureInfo } from '../culture-info.model';
import { CultureInfoAr } from './ar';

/**
 * @ignore
 */
export const CultureInfoArKW: CultureInfo = {
  name: 'ar-KW',
  displayName: 'Arabic (Kuwait)',
  iso3LanguageCode: 'ara',
  iso2LanguageCode: 'ar',
  ietfLanguageTag: 'ar-KW',
  parent: CultureInfoAr
};
